import React from "react";
import Chip from "@material-ui/core/Chip";

export default ({ value, onRemove }) => (
    <Chip key={value.value} label={value.label} onDelete={() => onRemove(value)} />
);